import React from "react";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { DropzoneArea } from "react-mui-dropzone";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import Button from "components/common/Button";

const UploadExcelModel = ({
  open,
  handleClose,
  onImageChange,
  onClickModel,
}) => {
  const classes = useStyles();
  const handleClick = () => {
    onClickModel();
  };
  return (
    <>
      <Dialog onClose={handleClose} open={open}>
        <Box className={classes.excel_box}
          sx={{
            boxSizing: "border-box",
            justifyContent: "center",
            alignItems: "center",
            width: "600px",
            background: "#FBF9F9",
            border: "1px solid #004AAD",
            borderRadius: "8px",
          }}
        >
          <Stack sx={{ justifyContent: "left", alignItems: "left", p: 3 }}>
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: " 20px",
                textAlign: "left",
                letterSpacing: "-0.01em",
                color: "#071B2A",
              }}
            >
              Upload Excel
            </Typography>
            <Typography
              sx={{
                fontWeight: "400",
                fontSize: "16px",
                textAlign: "left",
                letterSpacing: "-0.01em",
                color: "#A2A7AE",
              }}
            >
              Upload excel to add vehicle models and map connectors to it.
            </Typography>
          </Stack>
          <Box className={classes.form_container}>
            <DropzoneArea
              sx={{ color: "#E9E9E9" }}
              dropzoneText="Drag and drop here or Browse"
              dropzoneClass={classes.dropzone}
              Icon={() => (
                <CloudUploadIcon
                  sx={{ color: "#E9E9E9", fontSize: "6.5rem" }}
                />
              )}
              acceptedFiles={["image/jpeg", "image/png", "image/bmp"]}
              onChange={(file) => onImageChange(file)}
            />
            <Button
              variant="contained"
              fullWidth
              sx={{
                fontSize: "16px",
                mt: 2,
                mb: 2,
              }}
              onClick={() => (!handleClose() ? handleClick() : handleClose())}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  dropzone: {
    border: "2px dashed #E9E9E9",
  },
  form_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "540px",
    height: "305px",
    marginLeft: "4%",
    marginBottom: "10px",
    ["@media (max-width:768px)"]: {
      padding: "1rem",
      width: "90%",
      margin: "auto",
    },
  },
  excel_box: {
    ["@media (max-width:768px)"]: {
      width: "100%",

    },
  },
}));
export default UploadExcelModel;
